import React from 'react';
const styles = {"auth-divider":"AuthDivider-module__auth-divider__y6u85","rule":"AuthDivider-module__rule__ySrKo","label":"AuthDivider-module__label__kGMF-"};
export function AuthDivider({ label = 'or' }) {
    return (React.createElement("div", { className: styles['auth-divider'], role: "separator" },
        React.createElement("span", { className: styles.rule }),
        React.createElement("span", { className: styles.label }, label),
        React.createElement("span", { className: styles.rule })));
}
//# sourceMappingURL=AuthDivider.js.map